export default __webpack_public_path__ + "static/russian-3-f2650a03791dfe8384a836932fdd88af.jpg";